<template>
  <div class="camp-students">
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text="没有更多了"
      @load="loadMoreStudents"
    >
      <camp-person-card
        v-for="item in students"
        :key="item.id"
        :item="item"
        @open="goArchive(item)"
      ></camp-person-card>
    </van-list>
  </div>
</template>

<script>
import CampPersonCard from './components/CampPersonCard.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { getResearchCampMembers, getResearchCampStaffHomeLearners } from '@/api/researchCamp'
import { formatCampDate } from './date'

const CampStudents = {
  name: 'CampStudents',
  components: {
    CampPersonCard
  },
  data () {
    return {
      students: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      requestSeq: 0
    }
  },
  created () {
    this.loadStudents()
  },
  methods: {
    // 按角色加载学员。PD 和原中心走员工首页
    async loadStudents (append = false) {
      const campConfigId = this.$route.query.campConfigId
      const viewRole = this.$route.query.viewRole
      const isOriginalCenterRole = viewRole === 'ORIGINAL_CENTER_CAMP_DIRECTOR' ||
        viewRole === 'ORIGINAL_CENTER_FPE'
      if (!campConfigId && viewRole !== 'PD' && !isOriginalCenterRole) {
        this.$toast('缺少研修营信息')
        this.finished = true
        return
      }
      const requestSeq = append ? this.requestSeq : ++this.requestSeq
      const progressStatus = this.$route.query.progressStatus
      if (!append) {
        this.students = []
        this.pageNum = 1
        this.finished = false
        this.loading = true
      }
      try {
        const params = { progressStatus }
        let response
        if (viewRole === 'PD') {
          response = await getResearchCampStaffHomeLearners('PD', Object.assign({}, params, {
            campConfigId,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }))
        } else if (isOriginalCenterRole) {
          response = await getResearchCampStaffHomeLearners(viewRole, Object.assign({}, params, {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }))
        } else {
          response = await getResearchCampMembers(campConfigId, params)
        }
        if (requestSeq !== this.requestSeq) return
        const data = response && response.data ? response.data : []
        const isPaged = viewRole === 'PD' || isOriginalCenterRole
        const page = isPaged ? data : null
        const rows = isPaged ? (page.list || []) : (Array.isArray(data) ? data : [])
        const students = rows.map(item => ({
          id: item.campMemberId,
          campConfigId: item.campConfigId || campConfigId,
          name: item.name || '',
          level: item.currentIepLevel || item.entryIepLevel || '',
          center: item.campName || '',
          hospital: item.hospitalName || '',
          department: item.departmentL1 || '',
          title: item.positionTitle || '',
          joinDate: this.formatDate(item.entryTime)
        }))
        this.students = append ? this.students.concat(students) : students
        if (isPaged) {
          const currentPage = Number(page.pageNum) || this.pageNum
          this.pageNum = currentPage + 1
          this.finished = currentPage >= Number(page.pages) || students.length < this.pageSize
        } else {
          this.finished = true
        }
      } catch (error) {
        if (requestSeq !== this.requestSeq) return
        this.$toast(error && error.msg ? error.msg : '学员列表加载失败')
        this.finished = true
      } finally {
        if (requestSeq === this.requestSeq) this.loading = false
      }
    },
    // 加载下一页员工学员
    loadMoreStudents () {
      if (!this.finished) this.loadStudents(true)
    },
    // 入营时间格式化
    formatDate (value) {
      return formatCampDate(value)
    },
    // 进入该学员的培训档案
    goArchive (item) {
      this.$router.push({
        path: '/researchCamp/archive',
        query: {
          studentId: item.id,
          campConfigId: item.campConfigId || this.$route.query.campConfigId,
          viewRole: this.$route.query.viewRole
        }
      })
    }
  }
}

export default withRouteTracking(CampStudents)
</script>

<style lang="less" scoped>
@import './camp.less';

.camp-students {
  .camp-page();
  padding: 12px 0 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/students.vue